import { Text, Title2, WasabiButton } from '@kk/ui';

import { useClients, useSession } from '@/auth/SessionProvider';
import { deck } from '@/copy/deck';
import { SignInShell } from '@/screens/SignInShell';

/**
 * **A COMPANY ACCOUNT'S FIRST SIGN-IN, WITH NO ROLE YET** (board O00c, Evan 2026-09-26): "Ask an owner to add you". Every
 * owner was emailed when the request arrived, and it shows on their Team page; picking a role lets this person in on
 * their next load. The address is named, because the question somebody holding two accounts has is which one this is.
 */
export function AskAnOwner() {
  const { session } = useSession();
  const { auth } = useClients();
  return (
    <SignInShell>
      <div className="stack" data-testid="ask-an-owner">
        <Title2 tone="ink">{deck.o17.askAnOwner}</Title2>
        <Text variant="bodySm" tone="slate" testID="ask-an-owner-body">
          {deck.o17.askAnOwnerBody(session?.user.email ?? '')}
        </Text>
        <WasabiButton
          label={deck.states.notKkStaff.signOut}
          variant="text"
          textSize="sm"
          fullWidth={false}
          onPress={() => void auth.signOut()}
          testID="sign-out"
        />
      </div>
    </SignInShell>
  );
}
